import React from 'react';
import SeoScoreCard from './SeoScoreCard';
import { CompetitorsScoreData, ImportantFixData, ScoreData } from '../types';
import ImportantFixesCard from './ImportantFixesCard';

type Props = {
    id: string;
    reportGuid: string;
    url: string;
    scoreData: ScoreData;
    competitorsScoreData?: CompetitorsScoreData;
    importantFixesData?: ImportantFixData[];
    totalSectionsCount: number;
    createdAt: string;
    analysisProgress?: number;
    isFullReport?: boolean;
    showRefreshReport?: boolean;
    showDownloadPdf?: boolean;
    showWhiteLabel?: boolean;
    selectedSections: string[];
};

export default function ReportSummary({
    id,
    reportGuid,
    url,
    scoreData,
    competitorsScoreData,
    importantFixesData,
    totalSectionsCount,
    createdAt,
    analysisProgress,
    isFullReport,
    showRefreshReport,
    showDownloadPdf,
    showWhiteLabel,
    selectedSections
}: Props) {
    return (
        <div id={id}>
            <SeoScoreCard
                reportGuid={reportGuid}
                url={url}
                scoreData={scoreData}
                competitorsScoreData={competitorsScoreData}
                totalSectionsCount={totalSectionsCount}
                selectedSections={selectedSections}
                createdAt={createdAt}
                analysisProgress={analysisProgress}
                isFullReport={isFullReport}
                showDownloadPdf={showDownloadPdf}
                showWhiteLabel={showWhiteLabel}
                showRefreshReport={showRefreshReport}
            />

            {importantFixesData && importantFixesData.length > 0 && (
                <ImportantFixesCard
                    importantFixesData={importantFixesData}
                    createdAt={createdAt}
                    showLinksToIssues
                />
            )}
        </div>
    );
}
